"use client"
import {
  EnvironmentOutlined,
  FacebookOutlined,
  InstagramOutlined,
  PhoneOutlined,
  TwitterOutlined,
  WhatsAppOutlined,
  YoutubeOutlined,
} from '@ant-design/icons';
import { useTranslation } from '@root/src/i18n/client';

const FooterPage = () => {
  const { t } = useTranslation("common")
  const address = t('AddressContactss');
  const addressParts = address.includes(', Thành phố Hồ Chí Minh')
    ? address.split(', Thành phố Hồ Chí Minh')
    : [address];

  return (
    <footer className="w-full -mt-2 bg-[#223A27] px-6 pt-6 pb-8 text-xs text-white">
      <div className="container mx-auto px-4">
        <div className="grid gap-8 border-b border-white/15 pb-6 md:grid-cols-3 md:gap-10 md:items-start">
          <div className="space-y-4">
            <h3 className="text-xs uppercase tracking-[0.28em] text-white/75">
              {t("Follow Us")}
            </h3>
            <ul className="flex flex-wrap items-center gap-4 text-xl">
              <li><a href="https://www.facebook.com/share/1DToga9jmY/?mibextid=wwXIfr" className="text-white transition-opacity hover:opacity-80" aria-label="Facebook"><FacebookOutlined /></a></li>
              <li><a href="#" className="text-white transition-opacity hover:opacity-80" aria-label="Twitter"><TwitterOutlined /></a></li>
              <li><a href="#" className="text-white transition-opacity hover:opacity-80" aria-label="Instagram"><InstagramOutlined /></a></li>
              <li><a href="https://zalo.me/0931338566" className="text-white transition-opacity hover:opacity-80" aria-label="Zalo"><WhatsAppOutlined /></a></li>
              <li><a href="https://www.youtube.com/@mocphucduyen?si=JgRUfI-YfKSinCdR" className="text-white transition-opacity hover:opacity-80" aria-label="Youtube"><YoutubeOutlined /></a></li>
            </ul>
          </div>

          <div className="md:text-center">
            <div className="mb-2 flex items-center gap-2 text-white/75 md:justify-center">
              <PhoneOutlined />
              <span className="text-[11px] uppercase tracking-[0.22em]">{t("Phone Number")}</span>
            </div>
            <a
              href="tel:0931338566"
              className="text-sm font-medium text-white transition-opacity hover:opacity-80 md:text-base"
            >
              0931 338 566
            </a>
          </div>

          <div>
            <div className="mb-2 flex items-center gap-2 text-white/75">
              <EnvironmentOutlined />
              <span className="text-[11px] uppercase tracking-[0.22em]">{t("Address")}</span>
            </div>
            <p className="text-sm leading-6 text-white/95 md:text-base">
              {addressParts.length > 1 ? (
                <>
                  {addressParts[0]},
                  <br />
                  Thành phố Hồ Chí Minh
                </>
              ) : (
                address
              )}
            </p>
          </div>
        </div>

        <div className="mt-4 pt-2 text-center">
          <p className="text-[12px] text-white/75 md:text-sm">
            &copy; {new Date().getFullYear()} {t('Mộc Phúc Duyên')}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterPage;
